<template>
    <card class="card">
        <div class="card-body">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-copy text-primary"></i> {{$t('models.managetitle')}}
            </h2>
            <hr />
            <div>
                <div class="row">

                    <div class="col-md-6">

                        <div class="row">
                          <div class="col-md-8">
                            <fg-input
                                type="text"
                                :placeholder="$t('models.searchModels')"
                                v-model="form.name"
                            ></fg-input>
                          </div>

                          <div class="col-md-4">
                            <div class="form-group">
                              <button
                                class="btn btn-block btn-primary"
                                v-b-modal.addModel
                              >{{$t('models.button.add')}}</button>

                                  <b-modal
                                      id="addModel"
                                      ref="addModel"
                                      size="lg"
                                      class="card"
                                      hide-footer
                                      hide-header
                                      :title="$t('models.button.add')"
                                  >
                                      <h4 class="card-title pt-0 mt-0">{{$t('models.button.add')}}</h4>
                                      <hr />
                                      <form @submit.prevent id="formAddModel">
                                          <br />

                                          <div class="row">
                                            <div class="form-group col-md-4">
                                              <fg-input
                                                  type="text"
                                                  :label="$t('models.name')"
                                                  v-model="form.name"
                                              ></fg-input>
                                            </div>

                                            <div class="form-group col-md-4">
                                                <fg-input
                                                    type="text"
                                                    :label="$t('models.code')"
                                                    v-model="form.code"
                                                ></fg-input>
                                            </div>

                                          </div>

                                          <div class="row">
                                              <div class="col-md-12">
                                                  <p-button type="primary" @click.native.prevent="save">{{$t('repair.button.save')}}</p-button>
                                              </div>
                                          </div>
                                      </form>
                                  </b-modal>
                            </div>
                          </div>
                        </div>

                        <div>
                          <b-list-group>
                            <b-form-group :label="$t('models.listModels')" v-slot="{ ariaDescribedby }">
                              <b-list-group-item v-for="equipment in models">
                                  <b-form-radio v-model="model" :aria-describedby="ariaDescribedby" name="some-radios" value="A">Option A</b-form-radio>
                              </b-list-group-item>
                            </b-form-group>
                          </b-list-group>
                        </div>

                    </div>

                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-8">
                            <fg-input
                                type="text"
                                :placeholder="$t('models.searchParts')"
                                v-model="form.name"
                            ></fg-input>
                        </div>
                        <div class="col-md-4">
                           <button
                              class="btn btn-block btn-primary"
                              v-if="partsSelected"
                            >{{$t('models.button.linkParts')}}</button>
                        </div>
                      </div>
{{ teste()}}
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <b-list-group>
                              <b-form-group :label="$t('models.listParts')" v-slot="{ ariaDescribedby }">
                                <b-list-group-item v-for="part in parts">
                                    <b-form-checkbox
                                      id="checkbox-1"
                                      v-model="parts"
                                      name="checkbox-1"
                                      value="accepted"
                                      v-on:click="linkPart"
                                      unchecked-value="not_accepted"
                                    >
                                      I accept the terms and use
                                    </b-form-checkbox>
                                </b-list-group-item>
                              </b-form-group>
                            </b-list-group>
                          </div>
                        </div>
                      </div>
                    </div>

                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </card>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      model: [],
      partsSelected: false,
      form: {
        name: "",
        code: ""
      }
    };
  },
  computed: {
    ...mapState("models", {
      models: "all"
    }),
    ...mapState("parts", {
      parts: "parts"
    }),
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    }
  },
  mounted() {
    this.$store.dispatch("parts/getAll");
  },
  methods: {
    teste() {
      console.log(this.parts)
      // console.log(this.parts)
    },
    linkPart() {
      console.log(this.parts);
    },
    save() {
      this.$store.commit("models/set", this.form);
      this.$store
        .dispatch("models/add", this.form)
        .then(response => {
          this.$bvModal.hide('addModel');
          this.form.name = "";
          this.form.code = "";
          this.$notify({
            type: "success",
            horizontalAlign: "center",
            message: this.$t('models.message.successadd')
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  }
};
</script>
<style>
</style>
